import CompanyViewBeCareful from 'components/company-view/be-careful/company-view-be-careful';

import './company-view-be-careful.desktop.scss';

export default CompanyViewBeCareful;
